<template>
  <div class="templates-list">
    <ul>
      <li v-for="category in categories" :key="category" class="select-template-group">
        <button
          @click="getTemplates($event, category)"
          :title="category"
          class="select-template"
        >
          {{ category }}
        </button>
      </li>

      <li class="select-template-group all-template">
        <button
          @click="getTemplates($event)"
          :title="'All Templates'"
          class="select-template"
        >
          {{ parseTranslation(ALL_TEMPLATES) }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

import * as translationTemplateGroups from './TemplateGroups.translations'

const { default: translations, ...translationKeys } = translationTemplateGroups

export default {
  name: 'TemplateList',

  components: {},

  props: {
    templateCategories: {
      required: true,
    },
  },

  data() {
    return {
      translations,
      ...translationKeys,
      categories: [],
      selectorAllTemplates: false,
      selectedTemplates: [],
      selectedTemplatesInitial: [],
      loader: false,
    }
  },

  computed: {
    queryValue() {
      if (this.$route.query._q === '' || this.$route.query._q) return this.$route.query._q
      else return null
    },
  },

  watch: {
    queryValue() {
      this.searchQueryValue()
    },
  },

  methods: {
    ...mapActions(['sendMessage', 'executeSurveyAPICall']),

    searchQueryValue() {
      const arrayTemp = this.selectedTemplates
      if (this.queryValue) {
        this.selectedTemplates = arrayTemp.filter(item => {
          return this.queryValue
            .toLowerCase()
            .split(' ')
            .every(v => item.group_name.toLowerCase().includes(v))
        })
      } else {
        this.selectedTemplates = this.selectedTemplatesInitial
      }

      this.$emit('selectedTemplates', this.selectedTemplates)
    },

    async getCategories() {
      const categories = await this.executeSurveyAPICall({
        path: 'templates/categories',
        queryParams: {
          language: this.templateCategories.lang,
        },
      })

      if (!categories) return

      this.categories = categories
    },

    async getTemplates(e, category) {
      this.loader = true
      this.$emit('loader', this.loader)

      const templates = await this.executeSurveyAPICall({
        path: 'templates',
        queryParams: {
          language: this.templateCategories.lang,
          category: category || undefined,
        },
      })

      if (!templates) return

      this.selectedTemplates = templates
      this.selectedTemplatesInitial = templates

      this.$emit('selectedTemplates', templates)

      if (e !== undefined) this.displaySelected(e)

      if (!category) this.selectorAllTemplates = true

      const selectAll = document.querySelector('.all-template')

      if (this.selectorAllTemplates) selectAll.classList.add('active')

      this.loader = false
      this.$emit('loader', this.loader)
    },

    displaySelected(e) {
      const templates = document.querySelectorAll('.select-template-group')

      if (e !== undefined) {
        templates.forEach(anchor => {
          anchor === e.target.parentElement
            ? anchor.classList.add('active')
            : anchor.classList.remove('active')
        })
        this.selectorAllTemplates = false
      }
    },
  },
  created() {
    this.getCategories()
    this.getTemplates()
  },
}
</script>

<style lang="scss" scoped>
.templates-list {
  min-width: 190px;
  max-height: calc(100vh - 310px);
  overflow-y: auto;
  overflow-x: hidden;
  border-right: 1px solid $white;

  &::-webkit-scrollbar {
    width: 3px;
  }

  &::-webkit-scrollbar-track {
    background: $gray-6;
  }

  &::-webkit-scrollbar-thumb {
    background: $gray-7;
    border-radius: 5px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: $gray-8;
  }

  .light & {
    border-right: 1px solid $gray-5;

    &::-webkit-scrollbar-track {
      background: $white-3;
    }

    &::-webkit-scrollbar-thumb {
      background: $gray-10;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: $gray-11;
    }
  }

  ul {
    padding-bottom: 40px;

    li {
      display: flex;
      justify-content: center;
      cursor: pointer;
      @include tipography(16);
      position: relative;
      transition: all 0.5s ease-in-out;

      &:hover,
      &.active {
        background: rgba(255, 255, 255, 0.1);
        font-weight: bold;
      }

      .all-template {
        &.active {
          background: rgba(255, 255, 255, 0.1);
          font-weight: bold;
        }
      }

      .select-template {
        @include tipography(16);
        color: $white;
        text-align: center;
        height: 100%;
        width: 100%;
        display: block;
        padding: 15px 0;
        max-width: 32ch;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        border: none;
        background: $transparent;

        &:focus {
          outline: none;
        }
      }
    }
    .light & {
      li {
        &:hover,
        &:focus,
        &.active {
          background: rgba(0, 0, 0, 0.1);
        }

        .select-template {
          color: $gray-6;
        }
      }
    }
  }
}
</style>
